import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/simp_an/step3';
import { TypeObjCPVFNSSimple } from '../models/TypeObjCPVFNSSimple';
@Component({
	selector: 'app-type-objCPV',
	templateUrl: './type-objCPV.component.html'
})
export class TypeObjCPVComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeObjCPV';
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() cPV: TypeObjCPVFNSSimple;

	public step3 = new Step3();

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

}
